export const surprise = {
    btn_draw: 'ลุ้นรางวัล',
    confirm: {
        title: 'ยืนยันการเปิดถุง',
        msg: 'คุณต้องการใช้ {0}<br>ในการเปิดถุงหรือไม่?',
        msg_point: 'คะแนน',
        point_not_enough: 'คะแนนของคุณไม่เพียงพอ',
        btn_confirm: 'ยืนยัน',
        btn_cancel: 'ยกเลิก',
    },
    free: 'รับฟรี!',
    point_unit: 'คะแนน',
    pre_point_msg: 'ยินดีด้วย! คุณได้รับแต้ม<br>จำนวน {0} คะแนน',
    pre_campagin_msg: 'ยินดีด้วย! คุณได้รับส่วนลด Major มูลค่า 150 บาท จำนวน 1 รางวัล',
    pre_campagin_btnok: 'กดเพื่อดูรหัส',
    lose: 'ขออภัยค่ะ ท่านยังไม่ใช่ผู้โชคดี<br>มาร่วมกิจกรรมอีกครั้งวันพรุ่งนี้นะคะ',
    btn_close: 'ปิด',
    btn_history: 'ดูประวัติการใช้งาน',
    btn_success_confirm: 'ยืนยัน',
    btn_success_cancel: 'ยกเลิก',
    delivery_success: {
        title: 'รับสิทธิ์เรียบร้อยแล้ว',
        msg: 'บริษัทจะจัดส่งของรางวัลให้<br>ภายใน 14 วันทำการ',
        btn_cancel: 'ปิด',
        btn_ok: 'ดูประวัติ',
    },
    msg_free_delivery: 'ยินดีด้วย คุณได้รับ<br/>',
    msg_err: 'วันนี้คุณใช้สิทธิ์แล้ว<br/>พรุ่งนี้กลับมาลุ้นใหม่อีกครั้งนะคะ',
    msg_full: 'ขออภัยค่ะ ของรางวัลหมดแล้ว<br/>พบกันใหม่กิจกรรมหน้า<br/>ขอบคุณที่ร่วมสนุก',
    btn_diabled: {
        interval: 'วันนี้คุณใช้สิทธิ์แล้ว',
        expire_date: 'หมดเขตการเข้าร่วมกิจกรรม',
        full_quota: 'ขออภัย สิทธิ์เต็มจำนวนแล้ว',
        point_not_enough: 'คะแนนของคุณไม่เพียงพอ'
    },
    serial_condition: 'เงื่อนไข<br>&bull;สิทธิพิเศษสำหรับสมาชิก S Plus+ แอปพลิเคชัน<br>&bull;สิทธิพิเศษเป็นไปตามเงื่อนไข ข้อกำหนด และระยะเวลาที่บริษัทฯ ระบุไว้ใน S Plus+ แอปพลิเคชัน ทั้งนี้สิทธิพิเศษสามารถเปลี่ยนแปลงได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า<br>&bull;เพิ่มเติมที่ S Plus+ แอปพลิเคชัน',

    campaignExpired: 'หมดระยะเวลาร่วมกิจกรรม โปรดติดตามกิจกรรมดีๆ ในครั้งถัดไป',
    notEnoughPoint: 'ขออภัย คะแนนของท่านไม่เพียงพอในการร่วมกิจกรรม',
    soldOut: 'ขออภัย มีผู้ร่วมกิจกรรมครบตามจำนวนแล้ว โปรดติดตามกิจกรรมใหม่ในครั้งถัดไป',
    maxPerPerson: 'ขออภัย คุณใช้สิทธิ์ครบตามจำนวนที่กำหนด กรุณาร่วมสนุกใหม่ในครั้งถัดไป',
    redeemCoolDown: 'ขออภัย คุณใช้สิทธิ์ครบตามจำนวนที่กำหนด กรุณาร่วมสนุกใหม่ในครั้งถัดไป',
    condition: 'ขออภัย กรุณาตรวจสอบการตั้งค่าแคมเปญ'

}
